import {classNames, observer, React} from '@api'
import {Button} from '@blueprintjs/core'
import * as css from './CardSizePercentageLabel.css'
import {useCatalog} from '@stores'

export const CardSizePercentageLabel = observer<{ className?: string }>(function CardSizePercentageLabel({className}) {
  const {cardSizeSliderAsMultiplier, assortments, componentStores} = useCatalog()

  if (assortments?.selectedAssortment && componentStores.assortmentRoots['catalog']?.isCollapsedAll) {
    return null
  }


  return (<Button minimal className={classNames(css.cardSize, className)}>{(cardSizeSliderAsMultiplier * 100).toFixed(0)}%</Button>)
})


// WEBPACK FOOTER //
// ./src/modules/catalog/internal/CardSizePercentageLabel.tsx